import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'orderByName' })
export class OrderByNamePipe implements PipeTransform {
    transform(array: any[], field: string = 'name'): any[] {
        if (!Array.isArray(array)) return array;

        return array.slice().sort((a, b) => a[field].localeCompare(b[field]));
    }
}